import { render } from "./TableSettingsModal.vue?vue&type=template&id=734d407c&scoped=true"
import script from "./TableSettingsModal.vue?vue&type=script&lang=js"
export * from "./TableSettingsModal.vue?vue&type=script&lang=js"

import "./TableSettingsModal.vue?vue&type=style&index=0&id=734d407c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734d407c"]])

export default __exports__